"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-cycle */
const core_1 = require("@angular/core");
const moment_1 = __importDefault(require("moment"));
const interface_service_1 = require("../../../shared/interface/interface.service");
const notification_service_1 = require("../../../shared/browser-functions/notification.service");
const PREVIOUS_PWA_INSTALL_PROMPT = 'previousPwaInstallPrompt';
const PROMPT_EVERY_DAYS = 30;
/** Onboarding constists of two steps:
 * Step 1: Show PWA install prompt
 * Step 2: Once inside a PWA show notfication activation screen
 *
 * Step 1 is controlled by the `install-available-event` of `pwa-install`.
 * Once this is fired we show the install prompt and save, that we showed it
 * to the user to prevent it at the next app launch.
 *
 * Step 2: At app launch, we check if the app is installed as a PWA. If so
 * and we don't have a previous notification consent, we show the notification
 * onboarding screen.
 */
let OnboardingComponent = class OnboardingComponent {
    constructor(interfaceService, notificationService) {
        this.interfaceService = interfaceService;
        this.notificationService = notificationService;
        this.showNotificationScreen = false;
        /** Will be triggered by `pwa-install` Web Component.
         * Means, that the app can be installed as PWA and ist currently not yet. */
        this.installAvailableEvent = () => {
            const previousPrompt = localStorage.getItem(PREVIOUS_PWA_INSTALL_PROMPT);
            if (previousPrompt) {
                const parsedDate = (0, moment_1.default)(previousPrompt, 'YYYY-MM-DD');
                // Show banner X days after previous prompt
                if (parsedDate.add(PROMPT_EVERY_DAYS, 'd').isAfter((0, moment_1.default)()))
                    return;
            }
            console.info('Showing PWA install prompt.');
            this.showPwaDialog();
            localStorage.setItem(PREVIOUS_PWA_INSTALL_PROMPT, (0, moment_1.default)().format('YYYY-MM-DD'));
        };
        /** After successfull installation of PWA on Chrome. */
        this.installSuccess = () => {
            location.reload();
        };
        this.pwaIsInstallable = () => this.pwaElement.nativeElement.isInstallAvailable;
        this.showPwaDialog = () => this.pwaElement.nativeElement.showDialog();
        this.enableNotifications = () => {
            this.notificationService.onboardingEnableNotifications();
            this.showNotificationScreen = false;
        };
        this.declineNotifications = () => __awaiter(this, void 0, void 0, function* () {
            yield this.notificationService.onboardingDisableNotifications();
            this.showNotificationScreen = false;
        });
        this.showNotificationsOnboarding = () => {
            this.showNotificationScreen = true;
        };
        console.info('Onboarding Init');
        this.interfaceService.registerOnboardingComponent(this);
    }
    /** Step 2: Check if we need to show notification onboarding */
    ngAfterViewInit() {
        const pwaIsInstalled = this.pwaElement.nativeElement.isUnderStandaloneMode;
        const shouldShowOnboarding = this.notificationService.shouldShowOnboarding();
        if (pwaIsInstalled && shouldShowOnboarding)
            this.showNotificationScreen = true;
    }
};
__decorate([
    (0, core_1.ViewChild)('pwa'),
    __metadata("design:type", typeof (_a = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" ? _a : Object)
], OnboardingComponent.prototype, "pwaElement", void 0);
OnboardingComponent = __decorate([
    (0, core_1.Component)({
        selector: 'ab-onboarding',
        templateUrl: require('./onboarding.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _b : Object, typeof (_c = typeof notification_service_1.NotificationService !== "undefined" && notification_service_1.NotificationService) === "function" ? _c : Object])
], OnboardingComponent);
exports.default = OnboardingComponent;
